import request from '@app/utils/apiRequest';

export const requestGetDVTJCUVPipeLineList = (params) => request.get(`/dvtjcuv/dvtjcuv-pipeline/list`, {params: params});
export const requestGetDVTJCUVPipeLine = (params) => request.get(`/dvtjcuv/dvtjcuv-pipeline/detail`, {params: params});

export const requestDeleteDVTJCUVPipeline = (data) =>
    request.delete(`/dvtjcuv/dvtjcuv-pipeline/delete`, {data: data});

export const requestSaveDVTJCUVPipeline = (data) => request.post(`/dvtjcuv/dvtjcuv-pipeline/save`, data)
